<template>
  <div class="big">
    <!-- 选择类型弹窗 -->
    <el-dialog
      title="添加类型"
      :visible.sync="dialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="addbanner">
        <div style="margin: 20px 0">请选择Banner的类型</div>
        <div>
          <el-radio-group v-model="type">
            <el-radio :label="1">文章</el-radio>
            <el-radio :label="2">视频</el-radio>
            <el-radio :label="3">链接</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" plain size="medium"
          >取 消</el-button
        >
        <el-button type="primary" @click="addBanner" size="medium"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <div class="page_title">歧黄学院推荐页Banner设置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <el-button
            type="primary"
            @click="dialogVisible = true"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('654') : false
            "
            >添加Banner
          </el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="图片">
              <template slot-scope="scope">
                <img
                  :src="scope.row.image_url"
                  alt
                  style="width: 160px; height: 90px"
                />
              </template>
            </el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">文章</span>
                <span v-if="scope.row.type == 2">视频</span>
                <span v-if="scope.row.type == 3">链接</span>
              </template>
            </el-table-column>
            <el-table-column label="排序">
              <template slot-scope="scope">
                <el-button
                  @click="updateSort(scope.$index, 1)"
                  v-if="scope.$index != 0"
                  size="medium"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('653')
                      : false
                  "
                  >置顶</el-button
                >

                <el-button
                  v-if="scope.$index != 0"
                  @click="updateSort(scope.$index, 2)"
                  size="medium"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('653')
                      : false
                  "
                  >上移</el-button
                >

                <el-button
                  @click="updateSort(scope.$index, 3)"
                  v-if="scope.$index != tableData.length - 1"
                  size="medium"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('653')
                      : false
                  "
                  >下移</el-button
                >
                <el-button
                  @click="updateSort(scope.$index, 4)"
                  v-if="scope.$index != tableData.length - 1"
                  size="medium"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('653')
                      : false
                  "
                  >置底</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="Banner状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待发布</span>
                <span v-if="scope.row.status == 2">已发布</span>
                <span v-if="scope.row.status == 3">已下架</span>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="toDetail(scope.row.banner_id, scope.row.type)"
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('684')
                      : false
                  "
                  >详情</el-button
                >
                <el-button
                  @click="updateStatus(scope.row.banner_id, 2)"
                  type="text"
                  size="medium"
                  v-if="scope.row.status !== 2"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('656')
                      : false
                  "
                  >发布</el-button
                >
                <el-button
                  @click="updateStatus(scope.row.banner_id, 3)"
                  type="text"
                  size="medium"
                  v-if="scope.row.status == 2"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('656')
                      : false
                  "
                  >下架</el-button
                >
                <el-button
                  @click="delBanner(scope.row.banner_id)"
                  type="text"
                  size="medium"
                  v-if="scope.row.status !== 2"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('657')
                      : false
                  "
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      type: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取banner列表
    getList() {
      this.axios.post('platform/library/getRecommendBannerList').then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list;
        }
      });
    },
    //添加banner
    addBanner() {
      if (!this.type) {
        this.$message.error('请选择添加的banner类型');
        return false;
      }
      if (this.type == 1) {
        this.$router.push('addbanneressay');
      } else if (this.type == 2) {
        this.$router.push('addbannervideo');
      } else if (this.type == 3) {
        this.$router.push('addbannerlink');
      }
    },
    //删除banner
    delBanner(banner_id) {
      this.$confirm('您确定删除该Banner吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/library/deleteRecommendBannerInfo', { banner_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //发布 下架 banner
    updateStatus(banner_id, status) {
      let msg = '您确定要发布该Banner吗？';
      if (status == 3) {
        msg = '该Banner当前已发布，确定要下架吗？';
      }
      this.$confirm(msg, '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/library/changeRecommendBannerStatus', {
              banner_id,
              status
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },

    //详情
    toDetail(banner_id, type) {
      if (type == 1) {
        this.$router.push({ path: 'addbanneressay', query: { banner_id } });
      } else if (type == 3) {
        this.$router.push({ path: 'addbannerlink', query: { banner_id } });
      } else {
        this.$router.push({ path: 'addbannervideo', query: { banner_id } });
      }
    },
    //排序
    updateSort(index, status) {
      let data = this.tableData[index];
      this.tableData.splice(index, 1);
      //置顶
      if (status == 1) {
        this.tableData.splice(0, 0, data);
      }
      //上移
      if (status == 2) {
        this.tableData.splice(index - 1, 0, data);
      }
      //下移
      if (status == 3) {
        this.tableData.splice(index + 1, 0, data);
      }
      //置底
      if (status == 4) {
        this.tableData.push(data);
      }
      let list = [];
      list = this.tableData.map((item) => {
        item = _.pick(item, ['banner_id', 'sort']);
        return item;
      });
      this.axios
        .post('platform/library/editRecommendBannerSort', { list })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功');
            this.getList();
          }
        });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
}
.addbanner {
  padding: 0 0 30px 30px;
  box-sizing: border-box;
  text-align: left;
  border-bottom: solid 2px #e7e7e7;
}
</style>

